import { MUIBox, MUIGrid } from "@cobee/cobee-ui";
import confirmBenefitBagRemoval from "usecases/benefit-plan/confirm-benefit-bag-removal";
import removeBenefitBag from "usecases/benefit-plan/remove-benefit-bag";
import { hideModal } from "usecases/commons/hide-modal";
import BenefitBagCard from "v2/ui/components/SubsidySection/components/BenefitBagCard";
import { BenefitBagStates } from "v2/ui/components/SubsidySection/types/benefitBagStates";

export default function BenefitBagList({
  benefitModel,
  country,
}: {
  benefitModel;
  country;
}) {
  return (
    <MUIBox sx={{ maxWidth: "58.75rem", marginTop: "32px" }}>
      <MUIGrid container spacing={3} alignItems="stretch">
        {benefitModel.benefitBagConfig.map((bag) => {
          const { state, benefitBagConfigId } = bag;
          const { companyId, id } = benefitModel;
          if (state === BenefitBagStates.ACTIVE) {
            return (
              <MUIGrid item xs={6} key={benefitBagConfigId}>
                <BenefitBagCard
                  bag={bag}
                  companyId={companyId}
                  country={country}
                  benefitModelId={id}
                  removeBag={() => {
                    confirmBenefitBagRemoval({
                      country,
                      callback: async (notifyEmployees) => {
                        await removeBenefitBag({
                          companyId,
                          benefitPlanId: id,
                          benefitBagConfigId,
                          notifyEmployees,
                        });
                        hideModal();
                      },
                    });
                  }}
                />
              </MUIGrid>
            );
          }
          return null;
        })}
      </MUIGrid>
    </MUIBox>
  );
}
